import formInputsTypes from '../simulatorConstant';
import AxeManuel from 'assets/img/axe-manuel.png';
import AxeMotorise from 'assets/img/axe-motorise.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import MoteurVolet from 'assets/img/moteur-volet.png';
import VoletRoulant from 'assets/img/volet-roulant.png';
import VoletTablier from 'assets/img/volet-tablier.png';
const Options = {
	id: 'OptionsVR',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: "Autre main d'oeuvre",
	name: 'Options',
	className: 'col-12 mt-6',
	classGroup: 'simulator-check',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'Création volet roulant complet',
			value: 'Création volet roulant complet',
			label: 'Création volet roulant complet',
			isInline: true,
			lst_price: 0,
			product_id: 9495,
			description: '- Création complète d’un volet roulant.',
		},
		{
			id: 'Ouverture du coffre non difficile',
			label: 'Ouverture du coffre (non difficile)',
			value: 'Ouverture du coffre non difficile',
			isInline: true,
			lst_price: 0,
			product_id: 9495,
			description: '- Ouverture du coffre du volet roulant.',
		},
		{
			id: 'Ouverture du coffre difficile',
			label: 'Ouverture du coffre (difficile)',
			value: 'Ouverture du coffre difficile',
			isInline: true,
			lst_price: 0,
			product_id: 9495,
			description: '- Ouverture du coffre du volet roulant.',
		},
		{
			id: 'Tirage de ligne électrique',
			label: 'Tirage de ligne électrique',
			value: 'Tirage de ligne électrique',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Tirage de la ligne électrique pour alimentation moteur.',
		},
		{
			id: 'Mise en place des agrafes',
			label: 'Mise en place des agrafes',
			value: 'Mise en place des agrafes',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise en place des agrafes du tablier.',
		},
		{
			id: 'Branchement électrique',
			label: 'Branchement électrique',
			value: 'Branchement électrique',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Branchement électrique du moteur.',
		},
		{
			id: 'Réglage fin de course',
			label: 'Réglage fin de course',
			value: 'Réglage fin de course',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Réglage des fins de course du volet roulant.',
		},
		{
			id: 'Mise en service',
			label: 'Mise en service',
			value: 'Mise en service',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise en service et test du volet roulant.',
		},
		{
			id: 'Mise à la décharge',
			label: 'Mise à la décharge',
			value: 'Mise à la décharge',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise à la décharge des éléments déposés.',
		},
		{
			id: 'Fermeture du coffre',
			label: 'Fermeture du coffre',
			value: 'Fermeture du coffre',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Fermeture et remise en place du coffre.',
		},
	],
};

const voletComplet = {
	id: 'VOLET_COMPLET',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Volet complet',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: Options,
	nextStepData: Options,
	options: [
		{
			id: 'depose_volet_complet',
			label: 'Dépose volet complet',
			value: 'depose_volet_complet',
			description: '- Dépose complète du volet roulant existant avec sécurisation.',
			imageUrl: VoletRoulant,
			isInline: true,
		},

		{
			id: 'pose_volet_complet_standard',
			label: 'Pose volet complet (Accès standard)',
			value: 'pose_volet_complet_standard',
			description: '- Pose complète d’un volet roulant avec réglages et essais finaux.',
			lst_price: 180,
			imageUrl: VoletRoulant,
			isInline: true,
		},
		{
			id: 'pose_volet_complet_Difficile',
			label: 'Pose volet complet (Accès Difficile)',
			value: 'pose_volet_complet_Difficile',
			description: '- Pose complète d’un volet roulant avec réglages et essais finaux.',
			lst_price: 250,
			imageUrl: VoletRoulant,
			isInline: true,
		},
		{
			id: 'pose_volet_complet_ultra',
			label: 'Pose volet complet (Accès ULTRA DIFFICILE)',
			value: 'pose_volet_complet_ultra',
			description: '- Pose complète d’un volet roulant avec réglages et essais finaux.',
			lst_price: 400,
			imageUrl: VoletRoulant,
			isInline: true,
		},
	],
};

const tablier = {
	id: 'TABLIER',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Tablier',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: voletComplet,
	nextStep: voletComplet,
	options: [
		{
			id: 'depose_tablier',
			label: 'Dépose tablier',
			value: 'depose_tablier',
			description: '- Dépose du tablier existant avec précaution et mise en sécurité.',
			imageUrl: VoletTablier,
			isInline: true,
		},
		{
			id: 'pose_tablier_standard',
			label: 'Pose tablier (Accès standard)',
			value: 'pose_tablier_standard',
			description: '- Pose du tablier du volet roulant avec alignement et réglages.',
			lst_price: 180,
			imageUrl: VoletTablier,
			isInline: true,
		},
		{
			id: 'pose_tablier_Difficile',
			label: 'Pose tablier (Accès Difficile)',
			value: 'pose_tablier_Difficile',
			description: '- Pose du tablier du volet roulant avec alignement et réglages.',
			lst_price: 250,
			imageUrl: VoletTablier,
			isInline: true,
		},
		{
			id: 'pose_tablier_ultra',
			label: 'Pose tablier (Accès ULTRA DIFFICILE)',
			value: 'pose_tablier_ultra',
			description: '- Pose du tablier du volet roulant avec alignement et réglages.',
			lst_price: 350,
			imageUrl: VoletTablier,
			isInline: true,
		},
	],
};

const axeMotorise = {
	id: 'AXE_MOTORISE',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe motorisé',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: tablier,
	nextStep: tablier,
	options: [
		{
			id: 'depose_axe_motorise',
			label: 'Dépose axe motorisé',
			value: 'depose_axe_motorise',
			description: '- Dépose de l’axe motorisé existant du volet roulant.',
			imageUrl: AxeMotorise,
			isInline: true,
		},
		{
			id: 'pose_axe_motorise',
			label: 'Pose axe motorisé',
			value: 'pose_axe_motorise',
			description: '- Pose d’un axe motorisé pour volet roulant.',
			lst_price: 250,
			imageUrl: AxeMotorise,
			isInline: true,
		},
	],
};

const axeManuel = {
	id: 'AXE_MANUEL',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe manuel',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeMotorise,
	nextStep: axeMotorise,
	options: [
		{
			id: 'depose_axe_manuel',
			label: 'Dépose axe manuel',
			value: 'depose_axe_manuel',
			description: '- Dépose de l’axe manuel existant avec démontage sécurisé.',
			imageUrl: AxeManuel,
			isInline: true,
		},
		{
			id: 'pose_axe_manuel',
			label: 'Pose axe manuel',
			value: 'pose_axe_manuel',
			description: '- Pose d’un axe manuel pour volet roulant.',
			lst_price: 250,
			imageUrl: AxeManuel,
			isInline: true,
		},
	],
};

const MainOuvreDataVolet = {
	id: 'MOTEUR',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Moteur',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeManuel,
	nextStep: axeManuel,
	options: [
		{
			id: 'depose_moteur',
			label: 'Dépose moteur',
			value: 'depose_moteur',
			description: '- Dépose du moteur existant avec sécurisation de l’installation.',
			imageUrl: MoteurVolet,
			isInline: true,
		},
		{
			id: 'pose_moteur',
			label: 'Pose moteur',
			value: 'pose_moteur',
			description: '- Pose d’un moteur pour volet roulant avec réglages et essais complets.',
			lst_price: 250,
			imageUrl: MoteurVolet,
			isInline: true,
		},
	],
};

export default MainOuvreDataVolet;
